import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyEcardGuest = loadable(() => import(/* webpackChunkName: "content/ecard/guest" */ './EcardGuest'), 'EcardGuest');
